export default "__VITE_ASSET__Bln9KQSK__"